<template>
    <div class="or-admin-product-constructor-table-ceil">
        <div class="table flex-row">
            <div class="column flex-column" v-for="(column, column_i) in options.columns" :key="column_i" :style="`width: ${options.ceils.columns[column_i].width}; flex: ${options.ceils.columns[column_i].flex ? 1 :  'none'};`">
                <div :class="['row', 'flex-column', !options.root ? 'row-inner' : null, 'hover-border']" v-for="(row, row_i) in column" :key="row_i" :style="[`height: ${options.ceils.rows[row_i].height}; flex: ${options.ceils.rows[row_i].flex ? 1 : 'none'};`, row.style]" @click.self="$emit('show-edit', {options: row, parent_options: options, parent: parent})">
                    <div v-if="!row.child" class="text" @click.self="$emit('show-edit', {options: row, parent_options: options, parent: parent})">
                        <p class="p-text" @click="$emit('show-edit', {options: row, parent_options: options, parent: parent})" v-html="convertRowText(row.text.value)">
                        </p>
                    </div>
                    <or-admin-product-constructor-table-ceil @mouseenter.self="show_icon[column_i + '_' + row_i] = true" @mouseleave="show_icon[column_i + '_' + row_i] = false" v-else @show-edit="(data)=>{$emit('show-edit', data)}" :options="row.child" :parent="row" @edit-inner="(data)=>{$emit('edit-inner', data)}" style="width: 100%; height: 100%"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    components: {
        // orAdminProductConstructorTableCeil
    },
    props: {
        options: Object,
        parent: Object,
    },
    data() {
        return {
            show_icon: {},
        }
    },
    computed: {
    },
    methods: {
        ...mapActions({convertText: 'convertText'}),
        convertRowText(text) {
            const div = document.createElement('div');
            this.convertText({text, container: div});
            return div.innerHTML;
        }
    }
}
</script>

<style scoped>
    .or-admin-product-constructor-table-ceil {
        height: 100%;
        overflow: hidden;
    }
    .table {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .column {
        height: 100%;
        border-right:#EBB932 1px solid;
        position: relative;
        display: flex-block;
    }
    .column:last-of-type {
        border-right: none;
    }
    .row {
        position: relative;
        border-bottom:#EBB932 1px solid;
        width: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: auto;
    }
    .row:last-of-type {
        border-bottom: none;
    }
    .row-inner {
        border-right: none;
    }
    .row-inner:last-of-type {
        border-bottom: none;
    }
    .edit-icon {
        width: 20px;
        position: absolute;
        left: 10px;
        top: 10px;
    }
    .edit-icon:hover {
        background-color: rgb(70, 70, 70);
    }
    .p-text {
        margin: 10px;
        box-sizing: border-box;
    }
</style>